import ThearpistClientOnboarding from 'src/containers/TherapistClientProfile/Tabs/onboarding/ThearpistClientOnboarding';
import UserDocuments from '../../features/documents/UserDocuments';
import Appointments from '../../features/appointments/Appointments';
import StaffProfileScreen from 'src/containers/TherapistProfile/Tabs/Profile';
import ClientProfileScreen from 'src/containers/TherapistClientProfile/Tabs/profile/TherapistClientProfile';
import { User } from '../UserProfileHeader/types';
import './UserProfileContent.scss';
import {
  AppointmentsTab,
  DocumentsTab,
  OnboardingTab,
  ProfileTab,
} from '../UserProfileHeader/constant';
import { UserRoles } from '../../constants/UserRoles';
import { Typography } from "src/latest/src/components";


// TODO: ClientProfileScreen and StaffProfileScreen can be combined into one file in future

type props = {
  userProfileDetails: User;
  profileDetails: User;
  selectedTab?: string;
  assignedToSch?: User;
  showPage?: any;
};

export default function UserProfileContent({
  userProfileDetails,
  profileDetails,
  selectedTab,
  assignedToSch,
  showPage,
}: props) {
  const content = () => {
    switch (selectedTab) {
      case ProfileTab.hash:
        return (
          <>
            {userProfileDetails?.user_type?.includes(UserRoles.CLIENT) ? (
              <ClientProfileScreen
                profileDetails={profileDetails}
                assignedToSch={assignedToSch}
                therapistClientData={userProfileDetails}
              />
            ) : (
              <StaffProfileScreen
                showPage={showPage}
                selectedUserContext={userProfileDetails}
              />
            )}
          </>
        );
      case OnboardingTab.hash:
        return (
          <ThearpistClientOnboarding
            selectedUserId={userProfileDetails?.id}
            selectedUserContext={userProfileDetails}
          />
        );
      case AppointmentsTab.hash:
        return (
          <Appointments
            title="Upcoming Appointments"
            selectedUserId={userProfileDetails?.id}
            selectedUserType={userProfileDetails?.user_type}
            showSearch={true}
          />
        );
      case DocumentsTab.hash:
        return <UserDocuments selectedUserId={userProfileDetails?.id} />;
      default:
        return (
          <div className="mt-5">
            <Typography variant="size-26" color="color-28" weight="regular">
              No content Found. {selectedTab}
            </Typography>
          </div>
        );
    }
  };

  return <div className="therapist-client-profile">{content()}</div>;
}
